export const bytesToMegabytes = (bytes, convertToDecimalBinary) => {
  const divisor = convertToDecimalBinary ? 1024 : 1000;
  return bytes / divisor / divisor;
};
